{
  "SET_NEW_PASSWORD": {
    "TITLE": "새 비밀번호 설정",
    "PASSWORD": {
      "LABEL": "비밀번호",
      "PLACEHOLDER": "비밀번호",
      "ERROR": "비밀번호가 너무 짧습니다."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "비밀번호 확인",
      "PLACEHOLDER": "비밀번호 확인",
      "ERROR": "비밀번호가 일치하지 않습니다."
    },
    "API": {
      "SUCCESS_MESSAGE": "비밀번호가 성공적으로 변경되었습니다.",
      "ERROR_MESSAGE": "Woot 서버에 연결할 수 없습니다. 나중에 다시 시도해 주세요."
    },
    "CAPTCHA": {
      "ERROR": "인증이 만료되었습니다. 캡차를 다시 완료해 주십시오."
    },
    "SUBMIT": "보내기"
  }
}
